/* eslint-disable max-len */
export default {
  general: {
    back: 'Zurück',
    searchBtn: 'Suche',
    serverErrorsByCodes: {
      3: 'Mit Ihrer Server-Konfiguration ist etwas nicht in Ordnung. Bitte versuchen Sie es später noch einmal',
      54: 'E-Mail-Adresse ist nicht gültig',
      57: 'Das Email wurde nicht registriert',
      58: 'Falsches Passwort',
      59: 'Administrator mit solchen E-Mails existiert nicht',
      61: 'Benutzer oder Unternehmen mit eingegebener E-Mail-Adresse ist bereits vorhanden',
      62: 'Die Telefonnummer ist ungültig. Sollte nur Zahlen enthalten',
      64: 'Firma mit diesem Namen existiert im system',
      65: 'Altes Passwort ist falsch',
      1000: 'Benutzer ist kein Administrator.'
    },
    paginator: {
      noMoreItemsMessage: 'Sie haben das Ende der Liste erreicht'
    }
  },
  header: {
    companyName: 'treuhand-suche.ch',
    inputPlaceholder: 'Treuhänder suchen',
    menu: {
      blog: 'Blog',
      loginForCompanies: 'Login',
      profile: 'Profil',
      userName: 'User',
      myProfile: 'Mein Konto',
      myCompany: 'Mein Unternehmen',
      logout: 'Ausloggen',
      forCompanies: 'Für Treuhänder',
      forum: 'Forum'
    }
  },
  drawerMenu: {
      contacts: 'Kontakt',
      blog: 'Blog',
      forCompanies: 'Für Treuhänder',
      dataProtection: 'Datenschutzerklärung',
      agb: 'AGB',
      registration: 'Anmeldung für Treuhänder',
  },
  footer: {
    footerMenuPart: {
      forum: 'Forum',
      contacts: 'Kontakt',
      blog: 'Blog',
      faq: 'FAQ',
      forCompanies: 'Für Treuhänder',
      fb: 'Facebook',
      linkedIn: 'LinkedIn'
    },
    footerLowPart: {
      copyRight: 'treuhand-suche.ch © {{year}}',
      rights: 'Alle Rechte vorbehalten',
      terms: {
        agb: 'Impressum & AGB',
        agbMobile: 'AGB',
        dataProtection: 'Datenschutzerklärung'
      }
    }
  },
  homeFilter: {
    labels: {
      communicationPreferences: 'Fokus der Kundenbetreuung',
      servicesBasis: 'Treuhand Basis',
      specialOffer: 'Spezialangebot*',
    },
    placeholders: {
      zipCode: 'Postleitzahl',
      city: 'Ort',
      canton: 'Kanton',
      software: 'Buchhaltungsprogramm',
      industries: 'Branche',
      services: 'Spezialgebiet'
    },
    errors: {
      noCityFound: 'Kein gültiger Ort',
      noZipFound: 'Keine gültige PLZ'
    },
    comment: 'Mit dieser Auswahl finden Sie Treuhänder mit einem Spezialangebot, z.B. Rabatte oder Paketlösungen.'
  },
  modals: {
    auth: {
      registration: {
        header: 'Registrierung',
        userTabName: 'Für User',
        companyTabName: 'Für Treuhänder',
        bottomCapture: {
          text: 'Mit dem Klick auf den Button stimmen Sie unseren ',
          privacyBtn: 'AGB',
          and: ' und ',
          termsBtn: 'Datenschutzerklärung zu'
        },
        backToLoginMsg: 'Sie haben bereits registriert?',
        singInBtn: 'Anmelden',
        notificationBar: {
          success: 'Neues Konto registriert',
          error: 'Registrierung fehlgeschlagen'
        }
      },
      login: {
        header: 'Willkommen zurück',
        forgotPass: 'Haben Sie das Passwort vergessen?',
        noSignedMsg: 'Noch nicht registriert?',
        singUpBtn: 'Registrieren'
      },
      resetPass: {
        header: 'Passwort zurücksetzen',
        capture: 'Geben Sie zum Zurücksetzen des Passworts die E-Mail-Adresse ein. Sie erhalten das neue Passwort zugemailt'
      },
      sendMail: {
        header: 'Anscheinend ist Ihr Unternehmen bei uns bereits registriert',
        capture: 'Bitte schauen Sie sich dieses Profil an. Ist das Ihr Unternehmen?',
        desc: 'Falls nicht, geben Sie bitte Ihre E-Mail-Adresse und Firmennamen ein. Wir kontaktieren Sie baldmöglichst.',
      },
    },
    changeLogo: {
      header: 'Bild ändern',
      selectImage: 'Bild wählen',
      deleteImage: 'Bild löschen',
      close: 'Schliessen',
    },
    filters: {
      header: 'Filter',
      revertBtn: 'Zurück',
      applyBtn: 'Anwenden',
      languages: {
        Deutsch: 'Deutsch',
        Englisch: 'Englisch',
        Französisch: 'Französisch',
        Italienisch: 'Italienisch',
        Russisch: 'Russisch',
        Holländisch: 'Holländisch',
        Spanisch: 'Spanisch',
        Portugiesisch: 'Portugiesisch',
        Arabisch: 'Arabisch',
      }
    },
    changePass: {
      header: 'Passwort ändern',
      form: {
        oldPass: {
          label: "Altes Passwort",
          placeHolder: "Altes Passwort eingeben",
          errors: {
            required: 'Passwort ist erforderlich',
          }
        },
        newPass: {
          label: "Neues Passwort",
          placeHolder: "Geben Sie neues Passwort ein",
          errors: {
            required: 'Passwort ist erforderlich',
            equal: 'Neues Passwort muss ein anderes sein',
          }
        },
        repeatNewPass: {
          label: "Passwort wiederholen",
          placeHolder: "Passwort bestätigen",
          errors: {
            required: 'Passwort ist erforderlich',
            noEqual: 'Verschiedene Passwörter',
          }
        }

      },
      submitBtn: "Speichern",
      cancelBtn: "Abbrechen",
      changeBtn: 'Ändern',
    },
    resetPass: {
      header: 'Passwort zurücksetzen',

      form: {
        newPass: {
          label: {
            start: 'Das neue Passwort für das Profil "',
            end: '" ist: '
          },
          errors: {
            required: 'Passwort wird benötigt',
            equal: 'Neues Passwort muss anders sein',
          }
        },
        sendMail: {
          start: "Dieses Passwort wurde an",
          end: "gesendet"
        }
      },
      submitBtn: "SENDEN",
      cancelBtn: "Cancel",

      notificationBar: {
        success: 'Passwort wurde erfolgreich zurückgesetzt',
        error: 'Passwort zurücksetzen fehlgeschlagen'
      }
    },
    writeUs: {
      header: "Schreiben Sie uns",
      form: {
        companyName: {
          label: "Firmenname",
          placeHolder: "Firmenname eingeben",
          required: 'Firmenname ist erforderlich'
        },
        firstName: {
          label: "Ihr Name",
          placeHolder: "Name eingeben",
          required: 'Name ist erforderlich'
        },
        email: {
          label: "E-mail",
          placeHolder: "E-Mail-Adresse eingeben",
          required: "E-mail ist erforderlich",
          isNotValid: "E-Mail-Adresse ist nicht gültig"
        },
        comment: {
          label: "Ihre Nachricht",
          placeHolder: "Text eingeben",
          required: "Text ist erforderlich",
        },
        submitBtn: "Senden"
      },
      notificationBar: {
        success: "Ihr Kommentar wurde abgesandt",
        error: "Beim Senden ist ein Fehler aufgetreten. Übermittlung fehlgeschlagen"
      },
    },
    reviewAlert: {
      thanksText: 'Danke!',
      notification: 'Ihr Kommentar wird von unserem Team bearbeitet und gepostet.'
    },
    successModal: {
      thanksText: 'Vielen Dank für Ihre Anfrage!',
      notification: 'Ihre Mitteilung wurde an {{ company }} gesendet.',
      error: 'Senden fehlgeschlagen'
    }
  },
  forms: {
    common: {
      emailForm: {
        label: 'E-Mail',
        placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
        errors: {
          required: 'E-Mail-Adresse ist erforderlich',
          isNotValid: 'E-Mail-Adresse ist nicht gültig',
        },
        submitBtn: 'Senden',
      },
      companyName: {
        placeholder: 'Geben Sie Ihren Firmennamen ein',
        errors: {
          required: 'Firmennamen ist erforderlich',
        },
      },
      phoneNumber: {
        placeholder: 'Geben Sie Ihre Telefonnummer ein',
        errors: {
          required: 'Telefonnummer ist erforderlich',
        },
      },
      name: {
        label: 'Vorname Name',
        placeholder: 'Gib deinen Namen ein',
        errors: {
          required: 'Name ist erforderlich'
        },
      }
    },
    login: {
      labels: {
        email: 'E-Mail-Adresse',
        pass: 'Passwort'
      },
      placeholders: {
        email: 'E-Mail-Adresse',
        pass: 'Geben Sie das Passwort ein'
      },
      errors: {
        email: {
          required: 'E-Mail-Adresse ist erforderlich',
          isNotValid: 'E-Mail-Adresse ist nicht gültig'
        },
        pass: {
          required: 'Passwort ist erforderlich',
        }
      },
      submitBtn: 'Anmelden',
    }
  },
  homepage: {
    mainCapture: 'Finden Sie den passenden',
    mainCapturePartTwo: 'Treuhänder',
    mainCapturePartThree: 'oder',
    mainCapturePartFour: 'Buchhalter',
    secondaryCapture: 'Schweizer Treuhandbranche im Überblick',
    advancedFilterBtn: 'Erweiterte Suche',
    infoBlock: {
      freeProfiles: {
        header: 'Kostenlose Profilerstellung',
        capture: 'Als Treuhänder stellen Sie sich mit Ihrem Profil potenziellen Neukunden vor!'
      },
      companiesCount: {
        header: 'Über 2600 Treuhänder',
        capture: 'Die Datenbank umfasst die meisten Treuhänder in der Deutschschweiz. Und täglich werden es mehr...'
      },
      fields: {
        header: 'Detaillierte Filtermöglichkeiten',
        capture: 'Finden Sie einen Treuhänder mit einer passenden Fachvertiefeung oder filtern Sie nach zusätzlichen Kriterien, wie z.B. nach Stundensätzen.'
      },
      locations: {
        header: 'Treuhänder in der Nähe',
        capture: 'Wählen Sie einen Treuhänder in Ihrer Region. Alle Kantone der deutschsprachigen Schweiz sind vertreten.'
      },
    },
    companiesCarousel: {
      title: 'Neue',
      subtitle: 'Treuhänder-Profile',
      loadMoreBtn: 'Alle Treuhänder',
      goToCompanyBtn: 'Zum Treuhänder-Profil'
    },
    blogCarousel: {
      title: 'Blog',
      loadMoreBtn: 'Alle Beiträge'
    },
    headerBeforeRegistration: 'Erstellen Sie noch heute Ihr kostenloses Konto',
    subHeaderBeforeRegistration: 'Welche Vorteile bringt mir ein Eintrag in der Treuhandsuche?',
    registrationFormTitle: 'Melden Sie sich bei uns an!',
    registrationFormSubTitle: 'Und nutzen Sie alle Optionen gratis!',
    registrationForm: {
      labels: {
        name: 'Firmenname',
        phone: 'Telefonnummer',
        email: 'E-Mail-Adresse',
        pass: 'Passwort',
        confirmPassword: "Registrieren"
      },
      placeholders: {
        name: 'Wie heisst das Unternehmen?',
        phone: 'Was ist Ihre Telefonnummer?',
        email: 'Wie lautet Ihre E-Mail-Adresse?',
        pass: 'Passwort eingeben',
        confirmPassword: 'Passwort bestätigen',
      },
      errors: {
        name: {
          required: 'Firmenname ist erforderlich',
        },
        phone: {
          formatIsWrong: 'Nummerformat ist falsch',
        },
        email: {
          required: 'E-Mail-Adresse ist erforderlich',
          isNotValid: 'E-Mail-Adresse ist nicht gültig'
        },
        pass: {
          required: 'Passwort ist erforderlich',
        },
        confirmPass: {
          required: 'Passwortbestätigung ist erforderlich',
          confirmPassword: 'Nicht gleiche Passwörter'
        },

      },
      submitBtn: 'Registrieren',
      successMessage: 'Profil erfolgreich registriert'
    },
    infoTextInRegistrationSection: {
      first: {
        header: 'Werbung für Ihr Business',
        capture: 'Ihr Angebot und Ihre Services können Sie einem breiten Publikum vermitteln.',
      },
      second: {
        header: 'Ihren Brand stärken',
        capture: 'Machen Sie Ihr Unternehmen einer spezifischen Zielgruppe bekannt: Als lokale Marke, als Branchen-Spezialist oder als Preis-Leader.'
      },
      third: {
        header: 'Neue Kunden anwerben',
        capture: 'Durch treuhand-suche.ch lassen sich direkt Anfragen von Interessenten generieren. Gewinnen Sie neue Kunden durch ein attraktives Profil.',
      }
    },
    subscribeSection: {
      capture: 'Immer auf dem aktuellen Stand bleiben',
      email: {
        placeholder: 'Ihre E-Mail-Adresse',
        required: 'E-Mail-Adresse ist erforderlich',
        invalid: 'E-Mail-Adresse ist nicht gültig'
      },
      emailLabel: 'Ihre E-Mail-Adresse',
      subscribeBtn: 'Abonnieren',

    }
  },
  companies: {
    topCapture: 'Suchergebnisse',
    country: 'der Schweiz',
    selectPerPageCapture: 'Zeigen: ',
    profile: 'Profile',
    sortCapture: 'Sortieren: ',
    allOption: 'Alle',
    noCompaniesNoFoundByQuery: {
      firstPart: 'Leider hat Ihre Auswahl zu keinen passenden Resultate geführt...',
      secondPart: 'Aber wir haben diese Treuhänder in der Nähe gefunden:'
    },
    loadMoreCompaniesMobile: 'Weitere Firmenprofil',

    filter: {
      capture: 'Filter',
      clearFilterBtn: 'Leeren',
      clearFilterBtnMobile: 'Filter zurücksetzen',
      cantonTitle: 'Kanton',
      cityTitle: 'Ort',
      zipTitle: 'PLZ-Gruppe',
      rateTitle: 'Stundensatz',
      softwareTitle: 'Buchhaltungsprogramm',
      communicationPreferencesTitle: 'Fokus der Kundenbetreuung',
      servicesBasisTitle: 'Treuhand Basis',
      servicesTitle: 'Spezialgebiet',
      industriesTitle: 'Branche',
      specialOfferTitle: 'Spezialangebot',
      languagesTitle: 'Sprachen',
      memberTitle: 'Mitgliedschaften',
      taxRepresentationTitle: 'Steuervertretung',

      rates: {
        secretary: 'Sekretariat',
        expert: 'Experten',
        auditor: 'Mandatsleiter',
        accountant: 'Buchhaltung'
      },
      histogramTitle: 'Durchschnittsstundensatz:',
      histogramText: '{{ value }} pro Stunde',
      rangeInputMinLabel: 'Mindeststundensatz',
      rangeInputMaxLabel: 'Höchststundensatz',
      histogramResetBtn: 'Löschen',
      histogramSaveBtn: 'Speichern',

      searchPlaceholders: {
        kanton: 'Kanton suchen',
        city: 'Ort suchen',
        zip: 'PLZ suchen',
        software: 'Buchhaltungsprogramm suchen',
        service: 'Spezialgebiet suchen',
        industries: 'Branche suchen',
        language: 'Sprachen suchen',
      },
      searchErrorMessages: {
        kantonNotFound: 'Kein gültiger Kanton',
        cityNotFound: 'Kein gültiger Ort',
        zipNotFound: 'Keine gültige PLZ',
        softwareNotFound: 'Kein gültiger Buchhaltungsprogramm',
        serviceNotFound: 'Kein gültiger Spezialgebiet',
        industriesNotFound: 'Kein gültiger Branche',
        languageNotFound: 'Keine gültige Sprache',
      },
      drawerFilterTitle: 'Filter',
      drawerFilterSubmitBtn: 'Filter anwenden',
    },
    sorts: {
      mostPopular: 'Relevanz',
      views: 'Popularität',
      name: 'Alphabetisch'
    },
    companyCard: {
      servicesLabel: 'Spezialgebiet',
      rateLabel: 'Stundensatz in CHF',
      softwareLabel: 'Buchhaltungsprogramm',
      viewsLabel: 'Profil Clicks',
      viewProfileBtn: 'Zum Profil',
      basicService: 'Treuhand Basis',
      rates: {
        accountant: 'Buchhaltung',
        auditor: 'Mandatsleiter',
        expert: 'Experten',
        secretary: 'Sekretariat'
      },
      communicationPreferences: {
        online: 'Online Betreuung',
        betreuungVorOrt: 'Betreuung vor Ort'
      },
      infoTitles: {
        services:'Services:',
        languages:'Sprachen:',
        memberships:'Mitgliedschaften:',
        views:'Ansichten',
        foundingYear: 'Gründungsjahr:',
        vatNumber: 'MwSt-Nr:',
        employees: 'Mitarbeiterzahl:',
        description: 'Beschreibung:',
        hourlyRates: 'Stundensatz in CHF:',
        mainIndustries: 'Hauptbranchen:',
        team: 'Team:',
        companyPhotos: 'Firmenfotos:',
        swissFranc: 'CHF',
        secretary:'Secretary',
        auditor:'Auditor',
        accountant:'Accountant',
        expert: 'Expert',
      }
    }
  },
  companyItem: {
    capture: 'Mein Unternehmen',
    captureAccountant: 'Ihr Treuhänder',
    goBackBtn: 'Zurück',
    companyProfile: 'Firmenprofil',
    goBackProfile: 'Zurück zum Profil',
    companyLogoAltValue: 'Firmenlogo',
    communicationPreferences: {
      online:     'Online Betreuung',
      betreuungVorOrt: 'Betreuung vor Ort'
    },
    editBtn: 'Bearbeiten',
    verified: 'Verifiziert',
    notVerified: 'Nicht verifiziert',
    views: 'Ansichten',
    employees: 'Mitarbeiterzahl',
    yearOfFoundation: 'Gründungsjahr',
    mehrwertsteuerNum: 'MwSt-Nr',
    ratingCount: "{{ count }} Bewertung",
    ratingCount_plural: "{{ count }} Bewertungen",
    ratingComponent: {
      tooltip: {
        main: 'Durchschnittliche Bewertung auf',
        averageTreuh: 'treuhand-suche.ch',
        averageGoogle: 'Google My Business',
        averagePortal: 'Durchschnittliche Bewertungen aus 2 Portalen ',
        averageTreuhandvergleich: 'treuhandvergleich.ch*',
        reviews: 'Bewertungen',
        desc: '*Bewertungen wurden in ein ',
        descStarSystem: 'Fünf-Sterne-System umgerechnet'
      },
      noRating: 'Keine Angaben'
    },
    infoItemsCategoriesName: {
      desc: 'Beschreibung',
      rate: 'Stundensatz in CHF',
      services: 'Spezialgebiet',
      industries: 'Branche',
      languages: 'Sprachen',
      member   : 'Mitgliedschaften',
      software : 'Buchhaltungsprogramm',
      pictures : 'Firmenfotos',
      employees: {
        title: 'Team',
        managerEmployees: 'Geschäftsleitung',
        otherEmployees: 'Weitere Mitarbeiter'
      },
      specialOffer: 'Spezialangebot',
      taxRepresentation: 'Steuervertretung'
    },
    rates: {
      secretariat: 'Sekretariat',
      auditor: 'Mandatsleiter',
      accounting: 'Buchhaltung',
      experts: 'Experten'
    },
    infoBlock: {
      header: 'Ist dies Ihr Unternehmen?',
      subHeader: 'Schreiben Sie uns und legen Sie zusammen mit unseren Moderatoren ein kostenloses Konto an, um folgende Optionen nutzen zu können:',
      createAccount: 'Kontakt aufnehmen',
      listItem1: 'Kommentare von Usern beantworten',
      listItem2: 'Angaben über Ihr Unternehmen editieren',
      listItem3: 'Kernangebot publik machen',
      listItem4: 'Geschäftsführung und Mitarbeiter vorstellen',
      listItem5: 'Backlink auf Ihre Website setzen',
    },
    contactBlock: {
      header: 'Kontakt-Formular',
      required: '*Pflichtfeld',
      form: {
        firstName: {
          label: "Vorname",
          placeholder: "Vorname angeben",
          isRequired: 'Vorname ist erforderlich'
        },
        lastName: {
          label: "Nachname",
          placeholder: "Nachname angeben",
          isRequired: 'Nachname ist erforderlich'
        },
        companyName: {
          label: "Unternehmen",
          placeholder: "Wie heisst das Unternehmen?"
        },
        employeeCount: {
          label: "Anzahl Mitarbeiter",
          placeholder: "Anzahl Mitarbeiter angeben",
          isNotValid: {
            type: "Anzahl der Mitarbeiter muss eine Zahl sein",
            notLessOne: 'Anzahl der Mitarbeiter sollte nicht geringer sein 1'
          }
        },
        phoneNumber: {
          label: "Telefonnummer"
        },
        email: {
          label: "E-Mail-Adresse",
          placeholder: "Wie lautet Ihre E-Mail-Adresse?",
          isRequired: 'E-Mail-Adresse ist erforderlich',
          isNotValid: "E-Mail-Adresse hat falsches Format"
        },
        message: {
          label: "Kommentar",
          placeholder: "Geben Sie den Text Ihrer Anfrage an",
          isRequired: 'Text ist erforderlich'
        },
        submitBtn: "Senden"
      }
    },
    reviewsBlock: {
      headerCapture: 'Bewertungen',
      createReviewBtn: 'Neue Bewertung',
      answerBtn: 'Antworten',
      reportBtn: 'Report',
      ownerAnswerLabel: 'Offizielle Antwort',
      commentsTitle: 'Kommentare',
    }
  },
  companyEdit: {
    capture: 'Firmenprofil bearbeiten ',
    saveBtn: 'Speichern',
    addItemBtn: 'Hinzufügen',
    settingsTypes: {
      main: 'Hauptinformation',
      settings: 'Einstellungen',
      social: 'Website und Social Media',
      desc: 'Beschreibung',
      rate: 'Stundensatz in CHF',
      team: 'Team',
      services: 'Spezialgebiet',
      industry: 'Branche',
      languages: 'Sprachen',
      member: 'Mitgliedschaften',
      software: 'Buchhaltungsprogramm',
      pictures: 'Firmenfotos',
      specialOffer: 'Spezialangebot',
      taxRepresentation: 'Steuervertretung'
    },
    errorMessages: {
      name: 'Firmenname ist erforderlich',
      email: 'E-Mail-Adresse hat falsches Format',
      website: 'Geben Sie Ihre Website-Adresse im Format www.muster.ch ein',
      phone: {
        type: 'Telefonnummer darf nur Zahlen enthalten'
      },
      rate: {
        mustBeNumber: 'Nur Zahlen',
        maxLimit: 'Wert sollte kleiner sein als 500'
      },
      employeeCount: {
        type: 'Anzahl der Mitarbeiter muss eine Zahl sein',
        notLessOne: 'Anzahl der Mitarbeiter sollte nicht geringer sein 1'
      },
      fileSize: 'Datei ist zu groß (max 5 MB)',
      socialMedia: {
        skype: 'Skype-Name muss zwischen 6 und 32 Zeichen enthalten',
        whatsApp: 'Bitte geben Sie eine gültige Telefonnummer ein',
        default: 'Bitte geben Sie einen gültigen Link ein'
      },
    },
    rateWarningMsg: {
      title: 'Wichtig!',
      desc: 'Information zu den Stundensätzen tragen überproportional zum Ranking bei. Je höher ihr Ranking, desto weiter oben bei den Suchergebnissen erscheint Ihr Unternehmen. Darüber hinaus können die Kunden diese Information bei der Suche angeben. Fehlt sie in Ihrem Profil, wird sie in der Suche nicht berücksichtigt.'
    },
    selectPlaceholders: {
      canton: 'Kanton auswählen',
      industries: 'Auswahl',
      languages: 'Auswahl',
      member: 'Auswahl',
      software: 'Auswahl',
      services: {
        specialisation: 'Auswahl',
      },
      socialMedia: 'Auswahl'
    },
    labels: {
      name: 'Firmenname',
      canton: 'Kanton',
      city: 'Ort',
      street: 'Strasse und Hausnummer',
      streetPlaceholder: 'Strasse, Nr.',
      zip: 'PLZ',
      email: 'E-Mail-Adresse',
      phone: 'Telefon',
      planTier: 'Ihr Abo',
      employeeCount: 'Mitarbeiterzahl',
      website: 'Website',
      desc: 'Über Ihr Unternehmen',
      communicationPreferences: 'Fokus der Kundenbetreuung ',
      workingHours: 'Öffnungszeiten',
      workingHoursSelection: 'Ihre Auswahl',
      industries: 'Branchen',
      languages: 'Sprachen',
      member: 'Mitgliedschaften',
      software: 'Buchhaltungsprogramm',
      otherSoftware: 'Weitere Buchhaltungsprogramm',
      otherLanguages: 'Weitere Sprachen',
      otherMembers: ' Weitere Mitgliedschaften',
      rate: {
        secretary: 'Sekretariat',
        accountant: 'Buchhaltung',
        auditor: 'Mandatsleiter',
        expert: 'Experten',
      },
      services: {
        basics: 'Treuhand Basis',
        specialisation: 'Spezialgebiet'
      },
      yearOfFoundation: 'Gründungsjahr',
      mehrwertsteuerNum: 'MwSt-Nr',
      socialMedia: 'Social Media',
      specialOffer: 'Über Ihr Spezialangebot',
      taxRepresentationBlock: 'Steuervertretung',
      taxRepresentationField: 'ja'
    },
    notificationBar: {
      success: 'Profil gespeichert',
      error: 'Beim Speichern ist ein Fehler aufgetreten. Änderungen fehlgeschlagen',
      successUploadPicture: 'Bild gespeichert',
    },
    progressBar: {
      current: 'Aktuell ',
      completeText: 'Vervollständigen Sie Ihr Profil'
    },
    communicationPreferences: {
      online:     'Online Betreuung',
      betreuungVorOrt: 'Betreuung vor Ort'
    },
    workingHours: {
      days: {
        full: {
          monday: 'Montag',
          tuesday: 'Dienstag',
          wednesday: 'Mittwoch',
          thursday: 'Donnerstag',
          friday: 'Freitag',
          saturday: 'Samstag',
          sunday: 'Sonntag'
        },
        short: {
          monday: 'Mo',
          tuesday: 'Di',
          wednesday: 'Mi',
          thursday: 'Do',
          friday: 'Fr',
          saturday: 'Sa',
          sunday: 'So'
        }
      },
      add: 'Öffnungszeiten hinzufügen ',
      close: 'Öffnungszeiten löschen',
      form: 'von',
      to: 'bis',
      byAppointment: 'nach Vereinbarung',
      timeDimension: 'Uhr'
    },
    pictures: {
      delete: 'Löschen',
      addPhotos: 'Fotos hinzufügen',
    },
    socialMedia: {
      names: {
        facebook: 'Facebook',
        linkedIn: 'LinkedIn',
        skype: 'Skype',
        whatsApp: 'WhatsApp',
        twitter: 'Twitter',
        googleMyBusiness: 'Google My Business',
        youtube: 'Youtube'
      },
      placeholders: {
        website: 'www.muster.ch',
        facebook: 'https://www.facebook.com/...',
        linkedIn: 'https://www.linkedin.com/company/...',
        skype: 'Skype-Name',
        whatsApp: '+41000000000',
        twitter: 'https://www.twitter.com/...',
        googleMyBusiness: 'https://business.google.com/...',
        youtube: 'https://www.youtube.com/channel/...'
      }
    },
    teamSection: {
      managersTitle: 'Geschäftsleitung',
      othersStaffTitle: 'Weitere Mitarbeiter',
      addEmployeeBtn: 'Person hinzufügen',
      sexTypes: {
        male: 'Herr',
        female: 'Frau'
      },
      fieldLabels: {
        sexType: 'Anrede',
        firstName: 'Vorname',
        lastName: 'Nachname',
        jobTitle: 'Jobtitel',
        email: 'E-Mail',
        education: 'Ausbildung'
      },
      fieldPlaceholders: {
        jobTitle: 'e.g.: Co-Founder',
        education: 'e. g.: Master of Science in Finance'
      },
      errors: {
        jobTitleRequired: 'Berufsbezeichnung ist erforderlich'
      }
    },
    fieldComment: {
      settingsLogo: [
        'Ihr Logo wird besser gezeigt, wenn Sie eine PNG-Datei hochladen.',
        'Falls Ihr Logo aus einem Icon und einem Text besteht, laden Sie lieber nur den Icon-Teil hoch.'
      ],
      settingsEmail: [
        'Diese E-Mail-Adresse ist Ihr Login für dieses Profil.',
        'Diese E-Mail-Adresse wird verwendet, um Ihnen Kundenanfragen zu senden (von Kontaktformular).'
      ],
      main: [
        'Wählen Sie, welche Art der Zusammenarbeit Sie bevorzugen: «Persönliche Beratung vor Ort» oder «On-site service». Sie müssen sich für Ihre präferierte Betreuungsart entscheiden (keine Doppelauswahl).',
        'Die Kunden können dann gemäss ihrer Präferenz nach diesem Kriterium filtern.'
      ],
      desc: [
        'Bitte beschreiben Sie Ihr Unternehmen. Hier können Sie Ihre Dienstleistungen und Ihre Unternehmen genauer beschreiben. Diese Angaben werden bei den Filterkriterien nicht berücksichtigt und haben nur beschreibenden Charakter.'
      ],
      social: [
        'Geben Sie die Adresse Ihrer Website und Ihre Kontakte in sozialen Netzwerken oder Messenger an. Potenzielle Kunden können Sie so besser kennenlernen und sie bieten mehr Kontaktoptionen.'
      ],
      servicesBasicsList: [
        'Belegverbuchung', 
        'Geschäftsabschluss', 
        'Lohnbuchhaltung', 
        'Mehrwertsteuer', 
        'Steuererklärung juristische Personen', 
        'Steuererklärung natürliche Personen'
      ],
      servicesBasics: [
        'Diese Kompetenzen gehören zu den Basiskenntnissen jedes Treuhänders, der Buchhaltungsdienstleistungen anbietet. Falls Sie nur spezialisierte Dienstleistungen anbieten (z.B. juristische oder steuerliche Beratung), lassen Sie diese Option frei.'
      ],
      servicesSpecialization: [
        'Wählen Sie die Fachgebiete aus, in welchen Sie über besondere Expertise verfügen. Sie können maximal zwei Gebiete wählen.',
        'Kunden, die eine Beratung in diesen Fachgebieten suchen, können nach Ihren Spezialgebieten suchen.',
        'Gerne können Sie in der generellen Beschreibung auch weitere Kompetenzen angeben. Diese Information wird in der Suche jedoch nicht berücksichtigt.'
      ],
      industries: [
        'Wählen Sie die Branchen, in welchen Sie über vertiefte Erfahrung verfügen. Sie können maximal fünf Branchen auswählen.',
        'Kunden, die einen Treuhänder mit bestimmter Branchenerfahrung suchen, können dann gezielt nach dieser Branche filtern.'
      ],
      languages: [
        'Bitte geben Sie in welchen Sprachen Sie Kunden bedienen können. Wenn Sie keine passende Sprache in unserer Liste finden, können Sie diese als Freitext erfassen.',
        'Kunden, die einen Treuhänder mit einer bestimmten Sprache suchen, können dann gezielt nach diesem Kriterium filtern. Gesucht wird jedoch nur nach Sprachen aus der Liste.'
      ],
      software: [
        'Bitte geben Sie an, mit welchen Buchhaltungsprogrammen Sie arbeiten. Wenn Sie keine passende Software in unserer Liste finden, können Sie diese als Freitext erfassen.',
        'Kunden, die einen Treuhänder suchen, der mit einem bestimmten Buchhaltungsprogramm arbeitet, können dann gezielt nach diesem Kriterium filtern. Gesucht wird jedoch nur nach Buchhaltungsprogrammen aus der Liste.'
      ],
      pictures: [
        'Hier können Sie Fotos hochladen, um Ihr Unternehmen bildlich vorzustellen. Dies können beispielsweise Bilder Ihres Büros, der Umgebung oder des Teams sein. Oder Sie verwenden andere Bilder, die zu Ihrem Unternehmen passen.'
      ],
      member: [
        'Bitte geben Sie Ihre Mitgliedschaften an. Wenn Sie keine passenden Mitgliedschaften in unserer Liste finden, können Sie diese als Freitext erfassen.',
        'Kunden, die einen Treuhänder mit einer bestimmten Mitgliedschaft suchen, können dann gezielt nach diesem Kriterium filtern. Gesucht wird jedoch nur nach Mitgliedschaften aus der Liste.'
      ],
      specialOffer: [
        'Beschreiben Sie Ihre Spezialangebote. Dies können z.B. ein spezielles Start-up-Angebot oder ein attraktiver Fixpreis für die Steuererklärung sein.'
      ],
      taxRepresentation: [
        'Geben Sie bitte an, ob Sie für Ihre Kunden eine Steuervertretung anbieten.'
      ]
    }
  },
  reviewCreate: {
    header: 'Neuer Kommentar',
    submitBtn: 'Posten',
    userName: 'Gast',
    ratingCapture: 'Ihre Bewertung',
    headersCaptures: {
      info: 'Ihre Angaben',
      ownerAnswer: 'Ihre Antwort'
    },
    userDataForm: {
      labels: {
        name: 'Ihr Name',
        email: 'Ihre E-Mail-Adresse',
        text: 'Ihr Kommentar'
      }
    },
    notificationBar: {
      success: 'Ihr Kommentar wurde abgesandt',
      successRating: 'Bewertung gesendet',
      error: 'Beim Versenden Ihres Kommentars ist ein Fehler aufgetreten. Senden fehlgeschlagen'
    },
    commentPostedAfter: 'Ihr Kommentar wird nach Prüfung durch unsere Moderatoren gepostet',
    textValidationRequired: 'Text ist erforderlich',
    nameValidationRequired: 'Name ist erforderlich',
    emailValidationRequired: 'E-Mail-Adresse ist erforderlich',
    emailIsNotValid: 'E-Mail-Adresse ist nicht gültig',
  },
  profile: {
    header: 'Profil',
    profileTabs: {
      comments: 'Kommentare',
      settings: 'Einstellungen',
    },
    settings: {
      selectImage: 'Bild wählen',
    },
    labels: {
      name: 'Name',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      planTier: 'Abo ändern',
    },
    button: {
      save: 'Speichern',
      editCompanyProfile: 'Zum Profil',
      changePassword: 'Passwort ändern',
      resetPassword: 'Passwort zurücksetzen',
    },
    notificationBar: {
      successChangePass: 'Passwort geändert',
      successResetPass: 'Passwort wurde zurückgesetzt',
      successUpdateUser: 'Profil gespeichert',
      errorUpdateUser: 'Beim Speichern ist ein Fehler aufgetreten. Änderung fehlgeschlagen',
      errorChangePass: 'Änderung des Passwortes fehlgeschlagen'
    }
  },
  logoText: {
    changeLogo: 'Bild ändern'
  },
  contactsPage: {
    title: 'Über uns',
    contactTitle1: 'haben sie Fragen?',
    contactTitle2: 'Unser Team hilft Ihnen gerne!',
    contactDesc: 'Wenn Sie Hilfe zu Ihrem Konto benötigen, Fragen zur Nutzung der Plattform haben oder technische Probleme haben, zögern Sie bitte nicht, uns zu kontaktieren.',
    email: 'Email:',
    socialMedia: 'Sozialen Medien:',
    socialMediaFacebook: 'Folgen Sie uns auf Facebook',
    titleForm: 'Schreiben Sie uns',
    submitBtn: 'Senden',
    form: {
      labels: {
        name: 'Name',
        email: 'E-Mail-Adresse',
        text: 'Ihre Nachricht',
      },
      placeholders: {
        name: 'Name eingeben',
        email: 'E-Mail-Adresse eingeben',
        text: 'Text eingeben',
      },
      errors: {
        emailRequired: 'E-Mail-Adresse ist erforderlich',
        nameRequired: 'Name ist erforderlich',
        textRequired: 'Text ist erforderlich',
        isNotValid: 'E-Mail-Adresse ist nicht gültig'
      }
    },
    notificationBar: {
      success: 'Nachricht gesandt',
      error: 'Senden fehlgeschlagen',
    }
  },
  forCompanies: {
    title: 'Verbessern Sie Ihr Geschäft schon heute',
    titleDescription: 'Mit dem umfassendsten Treuhandverzeichnis der Schweiz und einem schlauen Algorithmus gelingt es uns, Kunden und Treuhänder ' +
      'optimal zu matchen und den Kunden eine bessere Vergleichbarkeit zu bieten. Nur ein zufriedener ' +
      'Kunde ist ein guter Kunde!',
    titleBtn: 'Los geht’s',
    contentTitleOne: 'Spezifische Werbung ohne Streuverluste',
    contentDescriptionOne: 'Mit treuhand-suche.ch steigern Sie Ihre Online-Präsenz und schärfen Ihr ' +
      'Geschäftsprofil. Ihnen bietet sich die einzigartige Möglichkeit, Ihren Bekanntheitsgrad zu erhöhen und Ihre Dienstleistungen bekanntzumachen. Zielgenaue ' +
      'Werbung ohne grosse Streuverluste erlaubt es Ihnen, gezielt Unternehmen zu finden (bzw. gefunden zu werden!), die genau diese Dienstleistungen benötigen, ' +
      'die Sie anbieten.',
    contentTitleTwo: 'Kundenakquisition',
    contentDescriptionTwo: 'Gewinnen Sie mehr neue Kunden und steigern dadurch Ihren Umsatz. Mit treuhand-suche.ch bekommt Ihr Unternehmen zudem die Möglichkeit, echtes Kundenvertrauen zu schaffen und sich einen guten Ruf zu erwerben.',
    singUpTitle: 'Melden Sie sich bei uns an!',
    singUpSubTitle: 'Und nutzen Sie alle Optionen gratis!',
    singUpDescription: 'Durch Verlinkung Ihres TreuhandSuche-Profils mit Ihrer Website steigern Sie den Web-Traffic ' +
      'Ihrer Website direkt und indirekt durch vermehrte organische Suchanfragen in Google.',
    submitButton: 'Registerieren',
  },
  agb: {
    pageTitle: 'Agb',
    firstSection: {
      header: '1. Generelles',
      text: 'Diese AGB gelten bei Nutzung der Website zwischen www.treuhand-suche.ch und dem Nutzer/Kunden. Die Domain www.treuhand-suche.ch ist auf Ray Altherr, Nossikerstrasse 9, 8610 Uster registriert. \n Durch Besuch dieser Website und/oder die Nutzung verschiedener zur Verfügung gestellter Tools erklärt der Nutzer sich mit den vorliegenden Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) einverstanden. Die Anbieterin ist berechtigt, diese AGB jederzeit anzupassen. Der Kunde kann die aktuelle Version auf www.treuhand-suche.ch finden.\n Der Anbieterin stehen sämtliche Eigentums- und Schutzrechte (z.B. Urheber- und Markenrechte) an Leistungen sowie Dokumentationen (z.B. Produktbroschüren, Webseite) zu. Die Anbieterin erteilt dem Kunden für die Laufzeit des Vertrags das unübertragbare, nicht ausschliessliche Recht zur vertragsgemässen Nutzung der vom Vertrag umfassten Leistungen und Dokumentationen.'
    },
    secondSection: {
      header: '2. Vertragsabschluss',
      text: 'Der Nutzer schliesst mit der Betreiberin einen Vertrag über die Nutzung der Vergleichsplattform ab, sobald der Kunde sein Konto (Benutzerskonto) mittels Registrierung geöffnet hat. Der Vertrag tritt nach erfolgreicher Durchführung der vorgesehenen Verifizierung in Kraft. Die Erstellung eines Benutzerkontos für Treuhänder ist gratis.\n Der Kunde erklärt sich damit einverstanden, dass die im Benutzerkonto hinterlegten Daten auf der www.treuhand-suche.ch veröffentlicht werden. Der Kunde räumt der Anbieterin sämtliche Rechte zur Nutzung, Bearbeitung und Publikation der Daten ein. Der Vertrag wird für unbestimmte Zeit abgeschlossen.\n Der Vertrag kann von jeder Partei jederzeit ohne Einhaltung einer Frist gekündigt werden. Die Kündigung führt zur vollständigen Löschung des Benutzerkontos inklusive sämtlicher Informationen von www.treuhand-suche.ch. Eine Kündigung durch den Kunden kann per E-Mail oder per Kontaktformular auf der Website erfolgen.\n Die Anbieterin ist nicht verantwortlich für Verzögerungen ihrer Leistungen, die entweder durch eine unvollständige, nicht vertragsgemässe oder nicht fristgerechte Erfüllung von Pflichten des Kunden gemäss Ziffer 6 verursacht werden.'
    },
    thirdSection: {
      header: '3. Dienstleistungen',
      text: '{{ 1 }} www.treuhand-suche.ch stellt eine Vergleichsplattform zur Verfügung, auf dieser Schweizer Treuhänder sich selbst präsentieren können.\n {{ 2 }} Die Daten umfassen u.a. folgende Informationen:\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Standort-Informationen des Kunden (z.B. Name des Unternehmens, Adresse, Telefonnummer, Öffnungszeiten)\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ redPoint }} weitere Daten (z.B. Attribute, Keywords, Bilder und Texte),\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Diese Daten stellt der Kunde im Benutzerkonto zum Zwecke der Publikation auf der www.treuhand-suche.ch zur Verfügung.\n {{ 3 }} Sämtliche Änderungen und Ergänzungen können vom Kunden zu einem späteren Zeitpunkt vorgenommen werden. Die Anbieterin kann die Daten des Kunden durch weitere Informationen ergänzen, welche aus öffentliche zugänglichen Quellen zu Verfügung stehen oder von Dritten beschafft werden.\n {{ 4 }} Die Anbieterin ist nicht verantwortlich für Verzögerungen ihrer Leistungen, die entweder durch eine unvollständige, nicht vertragsgemässe oder nicht fristgerechte Erfüllung von Pflichten des Kunden gemäss Ziffer 6 verursacht werden.\n {{ 5 }} www.treuhand-suche.ch ist nicht verpflichtet, die vom Kunden zur Verfügung gestellten Daten oder die Berechtigung des Kunden an den Daten zu prüfen. Die Anbieterin kann jedoch vom Kunden einen Berechtigungsnachweis verlangen und / oder die Publikation von Daten ablehnen, ändern oder löschen, wenn diese nach Ermessen der Anbieterin die Zusicherungen des Kunden gemäss Ziffer 6 verletzen oder andere sachlich gerechtfertigte Gründe bestehen. Die Anbieterin ist ebenfalls berechtigt, dem Kunden eine angemessene Frist zur Anpassung bzw. Löschung von Inhalten anzusetzen und ihre Leistungen nach unbenutztem Ablauf der Frist einzustellen. Der Kunde ist in diesem Fall berechtigt, geänderte Daten zu publizieren.\n {{ 6 }} Der Kunde nimmt zur Kenntnis, dass die auf der www.treuhand-suche.ch publizierten Informationen öffentlich und für jedermann verfügbar gemacht werden, und dass Dritte die auf www.treuhand-suche.ch publizierten Daten weiterverbreiten können, ohne dass die Anbieterin dies kontrollieren kann. Auch nach Löschung allen Daten auf www.treuhand-suche.ch können sie auf anderen, von Dritten kontrollierten Plattformen publiziert bleiben, worauf die Anbieterin keinen Einfluss hat. Der Kunde ist damit einverstanden.\n {{ 7 }} Die Anbieterin ist jederzeit berechtigt, Leistungen sowie die Vergütung anzupassen. Dazu gehören z.B. gestalterische Anpassungen, Anpassungen an technologische Erfordernisse bzw. Entwicklungen sowie Änderungen, Ersatz und Wegfall von Funktionalitäten bzw. zu publizierenden Inhalten. Die Anbieterin gibt dem Kunden wesentliche Änderungen von Leistungen sowie eine Anpassung der Vergütung in geeigneter Weise (z.B. in einem Informationsschreiben, per E-Mail oder auf der Rechnung) rechtzeitig im Voraus, wenn möglich 30 Tage vor Inkrafttreten, bekannt. Der Kunde ist in einem solchen Fall berechtigt, den Vertrag bis zum Ablauf der Ankündigungsfrist mit Wirkung auf das Inkrafttreten der Änderung zu kündigen, andernfalls gelten die Änderungen als akzeptiert.\n {{ 8 }} Bei direkten oder indirekten Verweisen auf fremde Internetseiten ist jegliche Haftung der Betreiberin ausgeschlossen. Die Betreiberin hat keinerlei Ein fluss auf die verlinkten Seiten. Für rechtswidrige, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart angebotener Informationen entstehen, haftet allein der Anbieter der verlinkten Seite.'
    },
    forthSection: {
      header: '4. Bewertungssystem',
      text: ' Die Anbieterin stellt ein Bewertungssystem zur Verfügung. Dieses umfasst Ratings (Vergabe von Sternen) und eine Kommentarmöglichkeit durch die Besucher der www.treuhand-suche.ch. Der Kunde stimmt mit Abschluss des Vertrags der Teilnahme am Bewertungssystem der Anbieterin zu.\n Die Anbieterin hat keine Verpflichtung, die Bewertungen zu kontrollieren. Die Anbieterin haftet in keiner Weise für die Bewertungen der Nutzer. Die Anbieterin hat das Recht, Bewertungen in ihrem alleinigen Ermessen ohne Vorankündigung zu sperren, zu löschen oder nicht freizuschalten.\n Der Kunde hat die Möglichkeit, auf die Kommentare in seinem Profil zu antworten.'
    },
    fifthSection: {
      header: '5. Benutzerkonto',
      text: 'Die Anbieterin stellt dem Kunden einen Zugriff auf das Benutzerkonto zur Verfügung, in dem der Kunde sein Profil mit allen Informationen jederzeit pflegen und anpassen kann.\n Die Anbieterin bestimmt die Art des Zugangsschutzes für das Benutzerkonto. Sie ist nicht verpflichtet, die Identitätsangaben der Benutzern zu prüfen und darf jeden Zugriff mit den korrekten Login-Daten als berechtigten Zugang betrachten. Der Kunde verpflichtet sich, seine Login-Daten vor Missbrauch zu schützen und steht der Anbieterin für jeden Schaden ein, welcher dieser aus einem Missbrauch entsteht.'
    },
    sixthSection: {
      header: '6. Pflichten des Kunden',
      text: ' Der Kunde ist für die Pflege der Inhalte im Benutzerkonto verantwortlich.\n Der Kunde gewährleistet, dass:\n {{ 1 }} Er sämtliche erforderlichen Rechte an den zugestellten Informationen besitzt und uneingeschränkt darüber verfügen kann oder vom Rechteinhaber die notwendigen Nutzungsrechte eingeholt hat;\n {{ 2 }} Er mit den Daten keine Drittrechte (z.B. Firmen-, Marken- und Urheberrechte) verletzt;\n {{ 3 }} Er uneingeschränkt berechtigt ist, der Anbieterin im Zusammenhang mit den Daten die in diesem Vertrag festgehaltenen Rechte zu erteilen;\n {{ 4 }} Die Daten im Benutzerkonto korrekt sind;\n {{ 5 }} Die Inhalte und damit verlinkte Webseiten alle gesetzlichen Vorschriften einhalten und insbesondere nicht pornografisch, rassistisch, diffamierend, beläs tigend, gewaltverherrlichend, sittenwidrig oder moralisch verwerflich sind.\n Wird die Anbieterin wegen einer Gewährleistungsverletzung des Kunden der obengenannten Rechten von Dritten in Anspruch genommen, führt der Kunde soweit prozessrechtlich möglich den Rechtsstreit auf seine Kosten und hält die Anbieterin vollumfänglich schadlos. Die Anbieterin informiert den Kunden innert angemessener Frist über geltend gemachte Ansprüche.'
    },
    seventhSection: {
      header: '7. Verfügbarkeit, Gewährleistung',
      text: 'Die Anbieterin bemüht sich, eine hohe Verfügbarkeit ihrer Leistungen und des Benutzerkontos sicherzustellen, übernimmt jedoch keine Gewähr für ein unterbruchs- und störungsfreies Funktionieren. Sie bemüht sich zudem, technische Störungen, welche in ihrem Machtbereich liegen, innert angemessener Frist zu beheben, übernimmt jedoch keine Gewähr für die Verfügbarkeit von technischem Support. Weitere Gewährleistungsansprüche des Kunden sind ausgeschlossen.\n Für die Gewährleistung durch den Kunden gilt Ziffer 6.'
    },
    eighthSection: {
      header: '8. Datenschutz',
      text: 'Es gilt die Datenschutzerklärung der Anbieterin in ihrer jeweils aktuellen Fassung, die auf der www.treuhand-suche.ch verfügbar ist.'
    },
    ninethSection: {
      header: '9. Gerichtsstand / Anwendbares Recht',
      text: 'Für allfällige Streitigkeiten zwischen der www.treuhand-suche.ch und ihren Nutzern/Kunden gilt Zürich als ausschliesslicher Gerichtsstand. Es gilt Schweizer Recht.'
    }
  },
  dataProtection: {
    pageTitle: 'Datenschutzerklärung',
    firstSection: {
      header: '1. Allgemeines',
      text: 'treuhand-suche.ch ist verantwortlich für die Erhebung, Verarbeitung und Nutzung Ihrer Daten. Das schweizerische Datenschutzrecht ist massgebend.\n Diese Datenschutzerklärung gilt für alle Ihre Daten, die uns bereits vorliegen oder die uns in Zukunft vorliegen werden. Bitte beachten Sie, dass wir die Datenschutzerklärung von Zeit zu Zeit anpassen können.'
    },
    secondSection: {
      header: '2. Daten',
      text: 'Grundsätzlich bekommt treuhand-suche.ch die Daten von Ihnen direkt. In bestimmten Fällen kann es vorkommen, dass die Daten von anderen Personen (z.B., wenn eine Drittperson ein Rating oder einen Kommentar abgibt, der sich auf Sie bezieht, wenn Ihr Arbeitgeber uns Ihre Kontaktangaben angibt usw.) oder Datenquellen (z.B. öffentlich zugängliche Information) stammen. Die Löschung oder Berichtigung Ihrer Daten ist jederzeit möglich. Dafür sollte eine von Ihnen erklärte Einwilligung in die Verwendung oder Verarbeitung personenbezogener Daten mit Wirkung für die Zukunft widerrufen werden. \n {{ 1 }} Zur Personendaten gehören die folgenden Informationen:\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Name \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Geschlecht \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Sprache \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ redPoint }} Adresse \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ redPoint }} Telefonnummer \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ redPoint }} E-Mail-Adresse \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Berufsbezeichnung \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Foto \n Die Daten können erhoben, gespeichert, genutzt, verarbeitet, archiviert oder gelöscht werden. \n Wenn die Personendaten über eine dritte Person auf der Plattform publiziert wurde, gehen wir davon aus, dass diese Person damit einverstanden ist und diese Datenschutzerklärung kennt. \n {{ 2 }} Weitere Daten, welche auf treuhand-suche.ch veröffentlicht werden: \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Bilder \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Texte \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Kommentare \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Bewertungen \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Videos \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Etc. \n {{ 3 }} Daten, welche bei der Verwendung der Website durch registrierte und nicht registrierte Nutzer ermittelt oder bekanntgegeben werden: \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} die IP- und MAC-Adresse bzw. Device-ID des verwendeten Geräts \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Cookies \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} von Nutzern aufgerufene Seiten und eingegebene Suchbegriffe \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Eingaben Dialogfelder \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Bewertungen \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Zeitpunkt und Dauer der Besuche \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Klicks \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Referent/Exit-URL \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Angaben zum Zeitpunkt der Verwendung \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Browser- und Gerätetyp sowie verwendeten Betriebssystem und Internet Service Provider'
    },
    thirdSection: {
      header: '3. Bearbeitungszwecke',
      text: 'Wir werden Personendaten für die folgenden Zwecke bearbeiten: \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Nutzerverwaltung, Identitätsprüfungen, Log-ins, Authentifizierungen \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Erstellen von Nutzerprofilen, Angebot von individuellen Diensten und relevanten Inhalten \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Angebot, Weiterentwicklung und Verbesserung unserer Dienste, Neuentwicklung von Diensten, Betrieb, Wartung, Optimierung und Gewährleistung der Sicherheit unserer Dienste und Infrastruktur; \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Pflege, Administration und Entwicklung unserer Kundenbeziehungen, Kommunikation mit Kunden und Dritten \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Kundendienst und Support \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Promotionen, Werbung und Marketing \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Führung, Abgleich und Aktualisierung von Datenbanken \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Qualitätskontrolle, Marktforschung, Erstellen von Statistiken, Berichten und Managementinformationen \n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{ redPoint }} Systemadministration, statistische Zwecke, Sicherungs- oder Trackingzwecke'
    },
    forthSection: {
      header: '4. Datensicherheit',
      text: 'Wir werden Ihre Daten sicher aufbewahren und daher alle angemessenen Massnahmen ergreifen, um Ihre Daten vor Verlust, Zugriff, Missbrauch oder Änderungen zu schützen. \n Unserer Dienste sehen die Veröffentlichung von Daten vor. Sie können in der Regel überall, auch ausserhalb der Schweiz, abgerufen werden. Das gilt ebenso für den dabei verwendeten Benutzernamen. Veröffentlichte Daten können durch uns oder Dritte auch auf anderen Plattformen und in anderen Medien veröffentlicht werden, von Suchmaschinen (wie z.B. Google) indexiert oder von Dritten weiterverbreitet, worauf wir keinen Einfluss haben. \n In manchen Fällen wird es erforderlich sein, dass wir Ihre Anfragen an mit uns verbundene Unternehmen weiterreichen, insbesondere im Bereich IT, Betrieb von Anwendungen, und mit der Bearbeitung und Speicherung von Daten beauftragt werden. Auch in diesen Fällen werden Ihre Daten vertraulich behandelt. Auftragsdatenbearbeiter, die Personendaten erhalten können, können sich in beliebigen Ländern befinden, insbesondere in der Schweiz, in europäischen Ländern und in den USA.'
    },
    fifthSection: {
      header: '5. Cookies',
      text: 'treuhand-suche.ch verwendet Cookies. Das sind kleine Textdateien, die einzelne Informationen auf die Festplatte speichern lassen. Cookies ermöglichen es, insbesondere Nutzungshäufigkeit und Nutzeranzahl der Seiten zu ermitteln, Verhaltensweisen der Seitennutzung zu analysieren, aber auch unser Angebot kundenfreundlicher zu gestalten. Cookies bleiben über das Ende einer Browser-Sitzung gespeichert und können bei einem erneuten Seitenbesuch wieder aufgerufen werden. Bei den meisten Web-Browsern werden Cookies automatisch akzeptiert. Wenn Sie das nicht wünschen, sollten Sie die Einstellungen Ihren Internetbrowser ändern.'
    },
    sixthSection: {
      header: '6. Google AdWords',
      text: 'treuhand-suche.ch nutzt das Google Conversion-Tracking. Sind Sie über eine von Google geschaltete Anzeige auf unsere WebSite gelangt, wird von Google Adwords ein Cookie auf Ihrem Rechner gesetzt. Das Cookie für Conversion-Tracking wird gesetzt, wenn ein Nutzer auf eine von Google geschaltete Anzeige klickt. Diese Cookies verlieren nach 30 Tagen ihre Gültigkeit und dienen nicht der persönlichen Identifizierung. Besucht der Nutzer bestimmte Seiten unserer Website und das Cookie ist noch nicht abgelaufen, können wir und Google erkennen, dass der Nutzer auf die Anzeige geklickt hat und zu dieser Seite weitergeleitet wurde. Jeder Google AdWords-Kunde erhält ein anderes Cookie. Cookies können somit nicht über die Websites von AdWords-Kunden nachverfolgt werden. Die mithilfe des Conversion-Cookies eingeholten Informationen dienen dazu, Conversion-Statistiken für AdWords-Kunden zu erstellen, die sich für Conversion-Tracking entschieden haben. Die Kunden erfahren die Gesamtanzahl der Nutzer, die auf ihre Anzeige geklickt haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite weitergeleitet wurden. Sie erhalten jedoch keine Informationen, mit denen sich Nutzer persönlich identifizieren lassen. Wünschen Sie kein Tracking, können Sie das hierfür erforderliche Setzen eines Cookies ablehnen – etwa per Browser-Einstellung, die das automatische Setzen von Cookies generell deaktiviert oder Ihren Browser so einstellen, dass Cookies von der Domain „googleleadservices.com“ blockiert werden. \n Bitte beachten Sie, dass Sie die Opt-out-Cookies nicht löschen dürfen, solange Sie keine Aufzeichnung von Messdaten wünschen. Haben Sie alle Ihre Cookies im Browser gelöscht, müssen Sie das jeweilige Opt-out Cookie erneut setzen.'
    },
    seventhSection: {
      header: '7. Google Analytics',
      text: 'treuhand-suche.ch verwendet Google Analytics, einen Webanalysedienst von Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Zur Deaktivierung von Google Analytiscs stellt Google unter https://tools.google.com/dlpage/gaoptout?hl=de ein Browser-Plug-In zur Verfügung. Google Analytics verwendet Cookies. Die durch den Cookie erfassten Informationen über die Nutzung unserer Seiten (einschliesslich Ihrer IP-Adresse) werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Wir weisen darauf hin, dass auf dieser Website Google Analytics um den Code „gat._anonymizeIp();“ erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu gewährleisten. Ist die Anonymisierung aktiv, kürzt Google IP-Adressen innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum, weswegen keine Rückschlüsse auf Ihre Identität möglich sind. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Google beachtet die Datenschutzbestimmungen des „Privacy Shield“-Abkommens und ist beim „Privacy Shield“-Programm des US-Handelsministeriums registriert und nutzt die gesammelten Informationen, um die Nutzung unserer Websites auszuwerten, Berichte für uns diesbezüglich zu verfassen und andere diesbezügliche Dienstleistungen an uns zu erbringen. Mehr erfahren Sie unter https://support.google.com/analytics/answer/6004245?hl=de.'
    },
    eighthSection: {
      header: '8. Urheberrechte',
      text: 'Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Website, gehören ausschliesslich dem Betreiber dieser Website oder den speziell genannten Rechteinhabern. Für die Reproduktion von sämtlichen Dateien ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.'
    },
    ninethSection: {
      header: '9. Allgemeiner Haftungsausschluss',
      text: 'Alle Angaben unseres Internetangebotes wurden sorgfältig geprüft. Wir bemühen uns, unser Informationsangebot aktuell, inhaltlich richtig und vollständig anzubieten. Trotzdem kann das Auftreten von Fehlern nicht völlig ausgeschlossen werden, womit wir keine Garantie für Vollständigkeit, Richtigkeit und Aktualität von Informationen auch journalistisch-redaktioneller Art übernehmen können. Haftungsansprüche aus Schäden materieller oder ideeller Art, die durch die Nutzung der angebotenen Informationen verursacht wurden, sind ausgeschlossen, sofern kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. \n Die Benutzung bzw. der Zugang zu dieser Website geschieht auf eigene Gefahr des Besuchers. Der Herausgeber, seine Auftraggeber oder Partner sind nicht verantwortlich für Schäden, wie direkte, indirekte, zufällige, vorab konkret zu bestimmende oder Folgeschäden, die angeblich durch den Besuch dieser Website entstanden sind und übernehmen hierfür folglich keine Haftung. \n Der Herausgeber übernimmt ebenfalls keine Verantwortung und Haftung für die Inhalte und die Verfügbarkeit von Webseiten Dritter, die über externe Links dieser Webseite erreichbar sind. Für den Inhalt der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich. Der Herausgeber distanziert sich damit ausdrücklich von allen Inhalten Dritter, die möglicherweise straf- oder haftungsrechtlich relevant sind oder gegen die guten Sitten verstossen.'
    }
  },
  pageNotFound: {
    title: 'Leider wurde die gewünschte Seite nicht gefunden',
    button: 'Zur startseite'
  },
  companyLanguages: {
    'Alle': 'Alle',
    'Deutsch': 'Deutsch',
    'Englisch': 'Englisch',
    'Französisch': 'Französisch',
    'Italienisch': 'Italienisch',
    'Russisch': 'Russisch',
    'Holländisch': 'Holländisch',
    'Spanisch': 'Spanisch',
    'Portugiesisch': 'Portugiesisch',
    'Arabisch': 'Arabisch',
    'Rätoromanisch': 'Rätoromanisch',
    'Bulgarisch': 'Bulgarisch',
    'Finnisch': 'Finnisch',
    'Griechisch': 'Griechisch',
    'Albanisch': 'Albanisch',
    'Rumänisch': 'Rumänisch ',
    'Slowakisch': 'Slowakisch',
    'Türkisch': 'Türkisch',
    'Hebräisch': 'Hebräisch',
    'Mazedonisch': 'Mazedonisch',
    'Serbokroatisch': 'Serbokroatisch',
    'Chinesisch': 'Chinesisch',
    'Polnisch': 'Polnisch',
    'Ungarisch': 'Ungarisch',
    'Norwegisch': 'Norwegisch',
    'Kroatisch': 'Kroatisch',
    'Serbisch': 'Serbisch',
    'Dänisch': 'Dänisch',
    'Schwedisch': 'Schwedisch',
    'Tschechisch': 'Tschechisch',
    'Tamil': 'Tamil',
    'Bosnisch': 'Bosnisch'
  },
  companyBasicsServices: {
    label: 'Treuhand Basis'
  },
  companySoftware: {
    'Alle': 'Alle',
    'Bexio': 'Bexio',
    'Banana': 'Banana',
    'Office Maker': 'Office Maker',
    'LoopsFinanz': 'LoopsFinanz',
    'Klara': 'Klara',
    'Abacus': 'Abacus',
    'Sage': 'Sage',
    'Comatic': 'Comatic',
    'CashCtrl': 'CashCtrl'
  },
  companyServices: {
    'Alle': 'Alle',
    'MWST-Fragen': 'Komplexe MWST-Fragen',
    'Lohnbuchhaltung': 'Komplexe Lohnbuchhaltung',
    'Personalwesen/Arbeitsrecht': 'Personalwesen/Arbeitsrecht',
    'Vorsorgeberatung': 'Vorsorgeberatung',
    'Wirtschaftsprüfung': 'Wirtschaftsprüfung',
    'Revision': 'Revision',
    'Juristische Beratung': 'Juristische Beratung',
    'Unternehmensberatung': 'Unternehmensberatung',
    'Steuerberatung Schweiz': 'Steuerberatung Schweiz',
    'Steuerberatung International': 'Steuerberatung International',
    'Erbschaftsberatung': 'Erbschaftsberatung',
    'Nachfolgeplanung': 'Nachfolgeplanung',
    'Immobilienverwaltung': 'Immobilienverwaltung',
    'Domizil-Services': 'Domizil-Services',
    'Firmengründung': 'Firmengründung',
    'Vermögensverwaltung': 'Vermögensverwaltung',
    'Finanzplanung': 'Finanzplanung',
    'Businesspläne': 'Businesspläne'
  },
  companyIndustries: {
    'Alle': 'Alle',
    'Gastgewerbe': 'Gastgewerbe / Beherbergung und Gastronomie',
    'Finanzen': 'Finanz- und Versicherungsdienstleistungen',
    'Information': 'Information und Kommunikation',
    'Landwirtschaft': 'Landwirtschaft, Forstwirtschaft und Fischerei',
    'Kunst': 'Kunst, Unterhaltung und Erholung',
    'Grundbesitz': 'Grundstücks- und Wohnungswesen',
    'Verkehr': 'Verkehr und Lagerei',
    'Autogewerbe': 'Autogewerbe',
    'Versorgung': 'Ver- und Entsorgung (Energie, Wasser etc.)',
    'Sonstige': 'Sonstige Dienstleistungen'
  },
  communicationPreferences: {
    online: 'Online Betreuung',
    betreuungVorOrt: 'Betreuung vor Ort'
  },
  findCompany: {
    companyTitleText: 'Suchen Sie einen Treuhänder?',
    companySecondaryText: 'Benötigen Sie eine Beratung bei der Firmengründung in Zürich? Oder brauchen Sie Hilfe mit der Mehrwertsteuer in Basel? Auf treuhand-suche.ch haben wir für Sie viele Anbieter der Treuhandbranche aus Zürich, Winterthur, Basel, Luzern, Bern, Solothurn und anderen deutschsprachigen Kantonen gesammelt. \n \n Die Auswahl der Services besteht u.a. aus Finanzbuchhaltung, Debitoren- und Kreditorenbuchhaltung, Lohnbuchhaltung, Personalwesen, Jahresabschluss, Steuererklärungen und weiteren Treuhand-Dienstleistungen. \n \n Dank der ausführlichen Profile können Sie einen passenden Treuhänder für sich finden oder ihm direkt auf treuhand-suche.ch eine Frage stellen. Die Suche eignet sich optimal für Schweizer Unternehmen (KMUs und Selbständige), aber auch für Privatpersonen – bei uns finden Sie die beste Option für Ihr Budget.'
  },

  companyBlockNoTimeToSearch: {
    title: 'Keine Zeit für die Suche nach einem Treuhänder?',
    descSecondary: 'Wir schätzen Ihre Zeit: Füllen Sie einfach unser Formular aus und wir matchen Ihre Bedürfnisse mit einem für Sie passenden Treuhänder. ',
    descThird: 'Wir verkaufen keine Leads, sondern stellen Ihre Information den am besten passendsten Treuhändern gratis zur Verfügung.',
    button: 'Zum Offerten-Formular',
  },

  companyBlockConfusingTrustMarket: {
    title: 'Unübersichtlicher Treuhandmarkt',
    descSecondary: 'Die Suche nach einem neuen Treuhänder ist zeitaufwändig: Der Treuhandmarkt hinsichtlich Spezialisierung und Preis unübersichtlich und mitunter intransparent.   Bei der Suche im Internet müssen Sie mehrmals die gleichen Fragen beantworten, um dann Offerten zu erhalten, die wiederum auf ihre Eignung analysiert werden müssen. ',
    descThird: 'Eine gewisse Zeitersparnis bieten Offertenportale. Man füllt einmal eine Anfrage aus und erhält mehrere Offerten. Das Offertenportal verkauft Ihren Lead an mehrere Anbieter, die Ihnen dann eine Offerte erstellen. Es erhält also der Meistbietende oder der schnellste Anbieter die Chance, Ihnen eine Offerte zu erstellen. Aber wäre es nicht besser, wenn Ihnen der passendste Treuhänder eine Offerte erstellt und nicht derjenige, der am meisten für den Lead bietet? – Genau dies wollen wir verbessern.',
  },

  companyBlockOptimalMatching: {
    title: 'Optimales Matching bei uns an erster Stelle',
    descSecondary: 'Wir haben für Sie detaillierte Treuhänder-Profile auf unserer Plattform gesammelt. Dort befinden sich alle wichtigsten Informationen zu Spezialisierungen, inklusive Preise bzw. Stundensätze. Oder vielleicht suchen Sie einen online Treuhänder? Definieren Sie selbst Ihre Auswahl-Kriterien!',
    descThird: 'Sie müssen nur einmal Ihre Anforderungen an den Treuhänder in unserem Formular erfassen und wir übernehmen das Matching mit einem passenden Treuhänder für Sie! Alternativ können Sie natürlich immer noch in unserer grossen Datenbank individuell nach Treuhändern suchen.',
  },

  companyBlockMap: {
    title: 'Treuhand-suche.ch ist eine Schweizer Online-Plattform, die Treuhänder und Unternehmen zusammenführt.',
    descSecondary: 'Unsere Datenbank verfügt über 2600 Treuhänder-Profile aus allen deutschsprachigen Kantonen: Zürich, Aargau, Appenzell Ausserrhoden, Appenzell Innerrhoden, Basel-Landschaft, Basel-Stadt, Bern, Freiburg, Glarus, Graubünden, Luzern, Nidwalden, Obwalden, Schaffhausen, Schwyz, Solothurn, St. Gallen, Thurgau, Uri, Wallis und Zug. Bei uns finden Sie einen Berater für Treuhand-Dienstleistungen: Finanzbuchhaltung, Lohnbuchhaltung, Steuern etc. ',
  },

  adminPanel: {
    header: {
      addNewCompany: 'treuhänder hinzufügen',
      admins: 'Bestehende Admins',
      myProfile: 'Mein Konto',
      logout: 'Ausloggen'
    },
    sidebar: {
      home: 'Home',
      company: 'Treuhänder',
      newsletter: 'Newsletter',
      profile: 'Profil',
      status: 'Status',
      comments: 'Kommentare'
    },
    companies: {
      companyProfile: 'FIRMENprofil',
      buttons: {
        activeCompany: 'aktive tREUHÄNDER',
        deleteCompany: 'gelöschte',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Bearbeiten',
        restoreTooltip: 'Wiederherstellen'
      },
      tableHeaders: {
        name: 'Firmenname',
        date: 'Erstellungsdatum',
        location: 'Ort',
        phone: 'Telefon',
        email: 'Email',
        planTier: 'Premium status',
        lastChanges: 'Letzte Änderung',
        action: 'AKtion'
      },
      totalCompany: 'Total Firmen:',
      companiesRender: 'Firmen',
      createDate: 'Erstelldatum:',
      lastEdit: 'Zuletzt bearbeitet:',
      from: 'von'
    },
    comments: {
      navigationButtons: {
        all: 'Alle',
        comments: 'Kommentare',
        responses: 'Antworten',
        rating: 'Bewertung'
      },
      controlButtons: {
        posted: 'Posten',
        edit: 'Bearbeiten',
        delete: 'Löschen'
      },
      modals: {
        title: 'Sind Sie sicher?',
        cancelBtn: 'Abbrechen',
        postBtn: 'Posten'
      },
      commentsName: 'Kommentar',
      ratingsName: 'Bewertung',
      commentsResponse: 'Antwort auf Kommentar',
      totalComments: 'Total',
      saveBtn: 'Speichern',
      commentStates: {
        deleted: 'Gelöscht',
        updated: 'Bearbeitet',
        posted: 'Gepostet'
      }
    },
    profile: {
      pageTitle: 'Mein Konto',
      saveBtn: 'Speichern',
      changePassBtn: 'Passwort ändern',
      passwordCapture: 'Passwort',
    },
    statuses: {
      buttons: {
        activeStatues: 'Alle Treuhänder',
        verifiedStatuses: 'Verifizierte',
        notVerifiedStatuses: 'Nicht Verifizierte'
      },
      tableHeaders: {
        name: 'Name',
        verification: 'Verifizierung'
      }
    },
    modals: {
      companyDeleteConfirmation: {
        text: 'Dieses Firmenprofil wird endgültig gelöscht. Der Vorgang kann nicht widerrufen werden.',
        cancelBtn: 'Abbrechen',
        approveBtn: 'Löschen'
      },
      postCommentConfirmation: {
        text: 'Sind Sie sicher?',
        approveBtn: ' Posten',
        cancelBtn: 'Abbrechen'
      },
      deleteCommentConfirmation: {
        text: 'Dieser Kommentar wird endgültig gelöscht. Der Vorgang kann nicht widerrufen werden.',
        approveBtn: 'Löschen',
        cancelBtn: 'Abbrechen'
      },
      deleteRatingConfirmation: {
        text: 'Diese Bewertung wird endgültig gelöscht. Der Vorgang kann nicht wiederrufen werden.',
        approveBtn: 'Löschen',
        cancelBtn: 'Abbrechen'
      },
      deletePictureCompany: {
        text: 'Sind Sie sicher?',
        approveBtn: ' Löschen',
        cancelBtn: 'Abbrechen'
      },
      saveChangesCompanyProfile: {
        text: 'Möchten Sie die vorgenommenen Änderungen speichern?',
        approveBtn: 'Ja',
        cancelBtn: 'Nein'
      },
    },
    dashbord: {
      premiumScoreLabel: 'Premium Score',
      premiumPlusScoreLabel: 'Premium Plus Score',
      dashbord: {
        logoLabel: 'Logo',
        cantonLabel: 'Kanton',
        baseAddressCityLabel: 'Stadt',
        baseAddressStreetLabel: 'Straße',
        baseAddressZipLabel: 'PLZ',
        baseTelLabel: 'Telefon',
        yearOfFoundationLabel: 'Gründungsjahr',
        workingHoursLabel: 'Arbeitszeiten',
        communicationPreferencesLabel: 'Kommunikationspräferenzen',
        infoLabel: 'Info',
        baseWebsiteLabel: 'Webseite',
        rateSecretaryLabel: 'Sekretär Tarif',
        rateAccountantLabel: 'Buchhalter Tarif',
        rateAuditorLabel: 'Prüfer Tarif',
        rateExpertLabel: 'Experte Tarif',
        employeesLabel: 'Mitarbeiter',
        servicesSpecialisationLabel: 'Dienstleistungen Spezialisierung',
        industriesLabel: 'Branchen',
        languagesLabel: 'Sprachen',
        memberLabel: 'Mitglied',
        softwareLabel: 'Software',
        picturesLabel: 'Bilder',
        employeeCountLabel: 'Anzahl Mitarbeiter',
        premiumScoreLabel: 'Premium Punkte',
        premiumPlusScoreLabel: 'Premium Plus Punkte',
        matchingCriteriaCantonZipCityLabel: 'Matching Kanton/PLZ/Stadt',
        matchingCriteriaHourlyRateLabel: 'Matching Stundenlohn',
        matchingCriteriaSoftwareLabel: 'Matching Software',
        matchingCriteriaCommunicationPreferencesLabel: 'Matching Kommunikationspräferenzen',
        matchingCriteriaAccountingBasisLabel: 'Matching Buchführungsgrundlage',
        matchingCriteriaSpecialisationLabel: 'Matching Spezialisierung',
        matchingCriteriaIndustriesLabel: 'Matching Branchen',
        matchingCriteriaSpecialOfferLabel: 'Matching Spezialangebot',
        profileCompletenessScoresTitle: 'Profilvollständigkeit',
        sumOfScoresTitle: 'Punkte-Summe',
        premiumTiersScoresTitle: 'Premium-Tarife',
        matchingCriteriaScoresTitle: 'Matching-Kriterien',
        adjustmentScoresTitle: 'Formular zur Punkteanpassung',
      },
      notificationBar: {
        success: 'Aktualisiert',
        error: 'Fehlgeschlagen'
      }
    },
  },

  planTier: {
    basic: "Basis",
    premium: "Premium",
    premiumPlus: "Premium Plus"
  }
};
